define("shared/components/shared/wizards/device-setup/step-one", ["exports", "@ember/component", "@ember/template-factory", "@ember/object/computed"], function (_exports, _component, _templateFactory, _computed) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"ember-classic-decorator",0,"@ember/object/computed",0,"@ember/component",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <section class="tOB--wizard">
    <div class="tOB--wizard__left">
      <img class="o--media" src="/assets/images/img--device__setup--1.png">
      <span class="u--ellipsis tOB--wizard__overlayText u--text--md qa--user_email">
        {{this.currentUserModel.email}}
      </span>
    </div>
    <div class="tOB--wizard__right">
      <h3 class="tOB--wizard__title">
        {{t "wizards.device_setup.title_1"}}
      </h3>
      <p class="u--m__b__lg">
        {{html-safe (t "wizards.device_setup.desc_1.desc" platform=@socialProfile.capitalizedProfileType)}}
        <ul class="tOB--wizard__ul--sm">
          <li class="tOB--wizard__li">
            {{html-safe (t "wizards.device_setup.desc_1.step_1")}}
          </li>
          <li class="tOB--wizard__li">
            {{html-safe (t "wizards.device_setup.desc_1.step_2" email=this.currentUserModel.email)}}
          </li>
        </ul>
        <Shared::Link
          @href="https://help.later.com/hc/articles/360043244813"
          @text={{t "shared_phrases.learn_more"}}
        />
      </p>
      <p class="u--text--md">
        {{ t "wizards.device_setup.desc_1.desc_info"}}
      </p>
      <Shared::AppstoreLinks 
       @origin="onboarding"
      />
    </div>
  </section>
  
  */
  {
    "id": "6sIJ2BVO",
    "block": "[[[10,\"section\"],[14,0,\"tOB--wizard\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"tOB--wizard__left\"],[12],[1,\"\\n    \"],[10,\"img\"],[14,0,\"o--media\"],[14,\"src\",\"/assets/images/img--device__setup--1.png\"],[12],[13],[1,\"\\n    \"],[10,1],[14,0,\"u--ellipsis tOB--wizard__overlayText u--text--md qa--user_email\"],[12],[1,\"\\n      \"],[1,[30,0,[\"currentUserModel\",\"email\"]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"tOB--wizard__right\"],[12],[1,\"\\n    \"],[10,\"h3\"],[14,0,\"tOB--wizard__title\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"wizards.device_setup.title_1\"],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--m__b__lg\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[[28,[37,0],[\"wizards.device_setup.desc_1.desc\"],[[\"platform\"],[[30,1,[\"capitalizedProfileType\"]]]]]],null]],[1,\"\\n      \"],[10,\"ul\"],[14,0,\"tOB--wizard__ul--sm\"],[12],[1,\"\\n        \"],[10,\"li\"],[14,0,\"tOB--wizard__li\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[[28,[37,0],[\"wizards.device_setup.desc_1.step_1\"],null]],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"li\"],[14,0,\"tOB--wizard__li\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[[28,[37,0],[\"wizards.device_setup.desc_1.step_2\"],[[\"email\"],[[30,0,[\"currentUserModel\",\"email\"]]]]]],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,2],null,[[\"@href\",\"@text\"],[\"https://help.later.com/hc/articles/360043244813\",[28,[37,0],[\"shared_phrases.learn_more\"],null]]],null],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--text--md\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"wizards.device_setup.desc_1.desc_info\"],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[8,[39,3],null,[[\"@origin\"],[\"onboarding\"]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@socialProfile\"],false,[\"t\",\"html-safe\",\"shared/link\",\"shared/appstore-links\"]]",
    "moduleName": "shared/components/shared/wizards/device-setup/step-one.hbs",
    "isStrictMode": false
  });

  let StepOne = (_dec = (0, _computed.reads)('auth.currentUserModel'), (_class = class StepOne extends _component.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "currentUserModel", _descriptor, this);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUserModel", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class));
  _exports.default = StepOne;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, StepOne);
});